import React, { useState } from "react";

import "./CommonStyle.css";
import { forgotPassword } from "../services/apiService";
import { toast } from "react-toastify";
import SideBar from "./SideBar";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState(null);

  const [sidebarOpen, setSidebarOpen] = useState(false);
  const toggleSidebar = () => setSidebarOpen((prev) => !prev);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("Loading...");

    try {
      let res = await forgotPassword("auth/forgot-password", email);
      if (res.data.success) {
        setStatus("If the email exists, a password reset link has been generated."
        );
        setEmail("");
      } else if (!res.data.success) {
        toast.error(res.data.message);
        return false;
      }
    } catch (error) {
      toast.error("Error fetching users:" + error);
      return false;
    }
  };

  return (
    <div className={`container dashboard ${sidebarOpen ? "sidebar-open" : ""}`}>
      
      <nav className="navbar navbar-expand-lg navbar-light bg-white border-bottom sticky-top">
        <div className="container">
          <a href="#home" className="logo">
            Casual <span>Tech</span>
          </a>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#mainNav"
            aria-controls="mainNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
            onClick={toggleSidebar}
          >
            <span className="navbar-toggler-icon"></span>
          </button>
        </div>
      </nav>

      

      {/* Body */}
      <div className="dashboard-body">
        {/* Sidebar */}
        <SideBar />

        {/* Main */}
        <main className="dashboard-main">
          <h2>Forgot Password</h2>
          <hr />
          <div style={{ maxWidth: 400 }}>
            <form onSubmit={handleSubmit}>
              <div className="form-group mb-3">
                <input
                  type="email"
                  className="form-control"
                  value={email}
                  required
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your registered email"
                />
              </div>
              <button type="submit" className="btn btn-primary">
                Send Reset Link
              </button>
            </form>

            <div style={{ marginTop: "50px" }}>
              {status && (
                <div className="alert alert-success">
                  <strong>
                    <svg
                      aria-hidden="true"
                      className="fc-success svg-icon iconCheckmarkLg"
                      width="36"
                      height="36"
                      viewBox="0 0 36 36"
                    >
                      <path d="m6 14 8 8L30 6v8L14 30l-8-8z"></path>
                    </svg>
                  </strong>{" "}
                  {status} <br />
                  <br />
                  <p>
                    If you don’t see this email in your inbox within 15 minutes,
                    look for it in your junk mail folder. If you find it there,
                    please mark it as “Not Junk”.
                  </p>
                </div>
              )}
            </div>
          </div>
        </main>
      </div>

      {/* Footer */}
      <footer className="dashboard-footer">
        © 2025 Casual Tech. All rights reserved.
      </footer>
    </div>
  );
};

export default ForgotPassword;
